import styled from "@emotion/native";
import Text from "../Text";

const KEY_WIDTH = 52;
const KEY_MARGIN = 18;

export const Container = styled.View({
	alignItems: "center",
	// backgroundColor: "blue",
});

export const Display = styled.View(
	{
		width: 231,
		height: 50,
		marginBottom: KEY_MARGIN,
		borderRadius: 5,
		alignItems: "center",
		justifyContent: "center",
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.text,
		};
	}
);

export const Input = styled.View({
	width: KEY_WIDTH * 3 + KEY_MARGIN * 3,
	height: KEY_WIDTH * 4 + KEY_MARGIN * 3,
	flexDirection: "row",
	flexWrap: "wrap",
	alignItems: "flex-start",
	justifyContent: "space-evenly",
});

export const Key = styled.View(
	{
		width: KEY_WIDTH,
		height: KEY_WIDTH,
		marginBottom: KEY_MARGIN,
		marginRight: KEY_MARGIN,
		left: KEY_MARGIN / 2,
		borderRadius: 26,
		alignItems: "center",
		justifyContent: "center",
	},
	({ theme, isActive }: any) => {
		return {
			backgroundColor: isActive ? "#073350" : theme.color.text,
			userSelect: "none",
		};
	}
);

export const KeyLabel = styled(Text)({}, ({ theme, isActive }: any) => {
	return {
		color: isActive ? theme.color.pinText : "#073350",
	};
});
